import { collection, deleteDoc, doc, DocumentReference, getDoc, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";
import RetVal, { RetValCode, RetValData } from "../../classes/retval.tsx";
import { Platform } from "../../classes/enums.tsx";
import { Solution } from "../../classes/solution.tsx";
import { containSolutionById } from "../../classes/utils/solution.tsx";

export async function adminExists(uid: string) {
    const adminDoc = await getDoc(doc(db, 'admins', uid));

    return adminDoc.exists();
}

export async function deleteDbDoc(doc:DocumentReference) {
    try {
        await deleteDoc(doc);
        return RetVal.ok('Documento eliminado');
    } catch (e) {
        console.log(e);
        return RetVal.error('Error al eliminar el documento');
    }
}

export async function getSolutionsCategories(): Promise<RetValData> {
    try {
        const dataDoc = await getDoc(doc(db, 'solutions', 'data'));

        return RetValData.ok_data('Not implemented yet', dataDoc.get('categories'));
    } catch (e) {
        console.log(e);
        return RetValData.error('Error al eliminar el documento');
    }
}

export async function getSolutionsByQuery(category: string | null, platform: Platform | null) : Promise<RetValData> {
    try {
        console.log(category, platform);

        const retVal:Solution[] = [];
        const ref = collection(db, 'solutions', 'solutions', 'solutions');

        if (category !== null && category !== undefined) {
            const q = query(ref, where('categories', 'array-contains', category));
            const result = await getDocs(q);

            for (const doc of result.docs) {
                retVal.push(Solution.fromJSON(doc.data(), doc.id));
            }
        }
        if (platform !== null && platform !== undefined) {
            const q = query(ref, where('platforms', 'array-contains', platform));
            const result = await getDocs(q);

            for (const doc of result.docs) {
                if (!containSolutionById(retVal, doc.id)) {
                    retVal.push(Solution.fromJSON(doc.data(), doc.id));
                }
            }
        }

        if ((category === null || category === undefined) && (platform === null || platform === undefined)) {
            const result = await getDocs(ref);

            for (const doc of result.docs) {
                retVal.push(Solution.fromJSON(doc.data(), doc.id));
            }
        }

        return new RetValData(RetValCode.OK, 'All ok', retVal);
    } catch (e) {
        console.log(e);
        return RetValData.error(e.message);
    }
}